<template>
    <div class="review-participant">
        <div class="review-participant__header">
            <div>
                <img src="@/assets/images/expert-panel/participant.svg" />
            </div>
            <div class="review-participant__title">
                Решение участника
            </div>
        </div>
        <div v-loading="loading">
            <ExpertPanelTabs>
                <ExpertPanelTab v-if="results.length > 0" title="На оценку">
                    <ExpertPanelReviewResults :data="results"/>
                </ExpertPanelTab>
                <ExpertPanelTab v-if="hasAbout" title="Об участнике">
                    <ExpertPanelReviewAbout :data="data" />
                </ExpertPanelTab>
                <ExpertPanelTab v-if="error" title="Ошибка">
                    <div class="review-participant__error">Ошибка загрузки данных</div>
                </ExpertPanelTab>
            </ExpertPanelTabs>
        </div>
    </div>
</template>

<script>
import ExpertPanelTabs from "@/components/expert-panel-new/ExpertPanelTabs.vue";
import ExpertPanelTab from "@/components/expert-panel-new/ExpertPanelTab.vue";
import ExpertPanelReviewResults from "@/components/expert-panel-new/review/ExpertPanelReviewResults.vue";
import ExpertPanelReviewAbout from "@/components/expert-panel-new/review/ExpertPanelReviewAbout.vue";
import { get } from "@/tools/http";

export default {
    name: "ExpertPanelReviewParticipant",
    components: {ExpertPanelReviewResults, ExpertPanelTab, ExpertPanelTabs, ExpertPanelReviewAbout},
    props: {
        review: Object,
        session: Object,
    },
    data() {
        return {
            data: {
                other: [],
            },
            loading: false,
            error: false,
        };
    },
    computed: {
        results() {
            return this.data.other
                ? this.data.other.filter((row) => row.name === undefined)
                : [];
        },
        hasAbout() {
            return (this.data.main && (
                    this.data.main.surname ||
                    this.data.main.name ||
                    this.data.main.patronymic
                )) ||
                (this.data.contacts && Object.keys(this.data.contacts).length > 0) ||
                (this.data.careers && this.data.careers.data && this.data.careers.data.length > 0) ||
                (this.data.education && this.data.education.higherEducations && this.data.education.higherEducations.length > 0) ||
                (this.data.documents && (
                        this.data.documents.inn && Object.keys(this.data.documents.inn).length > 0 ||
                        this.data.documents.residence && Object.keys(this.data.documents.residence).length > 0 ||
                        this.data.documents.snils && Object.keys(this.data.documents.snils).length > 0 ||
                        this.data.documents.birthCertificate && Object.keys(this.data.documents.birthCertificate).length > 0 ||
                        this.data.documents.workPermit && Object.keys(this.data.documents.workPermit).length > 0 ||
                        this.data.documents.foreignPassport && Object.keys(this.data.documents.foreignPassport).length > 0 ||
                        this.data.documents.identityDocument && Object.keys(this.data.documents.identityDocument).length > 0
                    )
                ) ||
                (this.data.other && this.data.other.filter((row) => !!row.name).length > 0);
        },
    },
    async created() {
        const userId = this.session.activitySession.userId;
        const taskId = this.review.activityId;
        this.loading = true;
        try {
            const resp = await get(
                'projects2',
                `api/v1/participant/${userId}/task/${taskId}/card/data`,
                {
                    isAnonymous: this.review.isAnonymous,
                },
                true,
            );
            this.data = resp;
        } catch (e) {
            this.error = true;
        } finally {
            this.loading = false;
        }
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.review-participant {
  font-family: Montserrat, sans-serif;
  background: #E1DFEC;
  box-shadow: 0 rem(2) rem(16) rgba(70, 99, 171, 0.16);
  border-radius: rem(16);
  overflow: hidden;
  &__header {
    display: flex;
    gap: rem(10);
    align-items: center;
    padding: rem(20) rem(40);
  }
  &__title {
    font-weight: 600;
    font-size: rem(20);
    line-height: rem(34);
    color: #2A2626;
  }
  &__error {
    text-align: center;
    font-size: rem(20);
    color: #DB6C61;
    margin: rem(40) 0;
  }
  :deep(.tabs__header-item_active) {
    display: list-item;
    list-style-type: disc;
    list-style-position: inside;
    span {
      margin-left: rem(-4);
    }
  }
  :deep(.tabs__body) {
    border-top-right-radius: 0;
  }
}
</style>